module.exports = __webpack_public_path__ + "img/会议记录.c82e01f4.svg";